/**
 * Descarga para Excel: CSV con punto y coma y BOM (así Excel en español lo abre con acentos y columnas bien).
 * Los números van con coma decimal, como los lee Excel configurado en Argentina.
 */
export type CsvValue = string | number | null | undefined;

const cell = (v: CsvValue): string => {
  if (v === null || v === undefined) return '';
  const s = typeof v === 'number' ? String(Math.round(v * 100) / 100).replace('.', ',') : v;
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename: string, headers: string[], rows: CsvValue[][]): void {
  const body = [headers, ...rows].map((r) => r.map(cell).join(';')).join('\r\n');
  const blob = new Blob(['﻿' + body], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Pesos (de centavos) y kilos (de gramos) como números para la planilla. */
export const pesos = (cents: number | null | undefined) => (cents === null || cents === undefined ? null : cents / 100);
export const kilos = (grams: number | null | undefined) => (grams === null || grams === undefined ? null : grams / 1000);
export const pct = (r: number | null | undefined) => (r === null || r === undefined ? null : Math.round(r * 1000) / 10);
